import {useRef} from 'react'

export const useProgressBarRef = () => {
  const progressBarRef = useRef<HTMLDivElement>(null)

  const updateProgress = (progress: number) => {
    if (progressBarRef.current) {
      // Update the scaleX transform directly based on progress
      progressBarRef.current.style.transform = `scaleX(${1 - progress})`
    }
  }

  return {
    progressBarRef,
    updateProgress,
  }
}
